import { ConditionsNew } from '@retail/calculus/types';
import { CreatePriceRoundingConditionContent } from '../../../Rounding';
import { InheritedConditionHint } from './InheritedConditionHint';

interface Props {
  editCondition?: ConditionsNew;
}

export function RoundingStep({ editCondition }: Props) {
  return (
    <>
      {editCondition && <InheritedConditionHint area="rounding" condition={editCondition} />}
      <CreatePriceRoundingConditionContent />
    </>
  );
}
